import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

// Configurable endpoint for mobile banner ads
const AD_API_ENDPOINT = "/flash-news";

class AdApi {
  getAds = async (params) => {
    try {
      const response = await api.get(AD_API_ENDPOINT, { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  };

  saveAd = async (data) => {
    try {
      const response = await api.post(AD_API_ENDPOINT, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to add ad";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  deleteAd = async (id) => {
    try {
      const response = await api.delete(`${AD_API_ENDPOINT}/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to delete Flash News";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const adApi = new AdApi();
export default adApi;

export const {
  getAds,
  saveAd,
  deleteAd,
} = adApi;
